import { render } from "./IconRfidPowerLow.vue?vue&type=template&id=45a38148"
import script from "./IconRfidPowerLow.vue?vue&type=script&lang=ts"
export * from "./IconRfidPowerLow.vue?vue&type=script&lang=ts"
script.render = render

export default script